import { ICartEntryType } from './types';
import type { ILegacyCartEntry } from './types';

const getCartEntryItemId = (cartEntry: ILegacyCartEntry): string => {
  if (cartEntry.type === ICartEntryType.REWARD) {
    return cartEntry.details.reward._id;
  }

  return cartEntry.details.offer._id;
};

export const isCartEntryEqual = (
  cartEntry: ILegacyCartEntry,
  cartEntryToCompare: ILegacyCartEntry
) =>
  cartEntry.referenceId === cartEntryToCompare.referenceId ||
  (cartEntry.type === cartEntryToCompare.type &&
    getCartEntryItemId(cartEntry) === getCartEntryItemId(cartEntryToCompare));
